import React from 'react';
import useOrganization from '../../../../../../hooks/api/useOrganization';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import OrganizationDetails from './OrganizationDetailsContent';
import OrganizationEditContent from './OrganizationEditContent';

export type OrganizationTabOwnProps = {};

export type OrganizationTabProps = OrganizationTabOwnProps;

const OrganizationTab: React.FC<OrganizationTabProps> = (_props) => {
    const { myOrganization, isLoadingMyOrganization } = useOrganization({});
    const [isEditing, setIsEditing] = React.useState(false);
    return (
        <AnimateLoadedContent isLoading={isLoadingMyOrganization}>
            {() =>
                isEditing ? (
                    <OrganizationEditContent
                        organization={myOrganization}
                        onCancel={() => setIsEditing(false)}
                        onUpdate={() => setIsEditing(false)}
                    />
                ) : (
                    <OrganizationDetails
                        organization={myOrganization}
                        onEdit={() => {
                            setIsEditing(true);
                        }}
                    />
                )
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(OrganizationTab);
